(function () {
  const root = document.querySelector('[data-header-ectra]');
  if (!root) return;

  const shell = root.querySelector('.header-ectra__shell');
  const menuBtn = root.querySelector('[data-header-ectra-menu-open]');
  const mobileNav = root.querySelector('#HeaderEctraMobileNav');
  const closeEls = root.querySelectorAll('[data-header-ectra-menu-close]');

  const scrollThreshold = Math.max(8, parseInt(root.dataset.scrollThreshold || '16', 10) || 16);

  function syncScroll() {
    const y = window.scrollY || document.documentElement.scrollTop;
    root.classList.toggle('header-ectra--scrolled', y > scrollThreshold);
  }

  let scheduled = false;
  function onScroll() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      syncScroll();
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  syncScroll();

  function setMenuOpen(open) {
    root.classList.toggle('header-ectra--menu-open', open);
    if (menuBtn) {
      menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      const openLabel = menuBtn.dataset.ariaLabelOpen;
      const closeLabel = menuBtn.dataset.ariaLabelClose;
      if (openLabel && closeLabel) {
        menuBtn.setAttribute('aria-label', open ? closeLabel : openLabel);
      }
    }
    if (mobileNav) {
      mobileNav.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (open) mobileNav.removeAttribute('inert');
      else mobileNav.setAttribute('inert', '');
    }
  }

  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', () => {
      const open = !root.classList.contains('header-ectra--menu-open');
      setMenuOpen(open);
    });
  }

  const desktopMq = window.matchMedia('(min-width: 768px)');
  function closeMenuIfDesktop() {
    if (desktopMq.matches && root.classList.contains('header-ectra--menu-open')) {
      setMenuOpen(false);
    }
  }
  if (typeof desktopMq.addEventListener === 'function') {
    desktopMq.addEventListener('change', closeMenuIfDesktop);
  } else if (typeof desktopMq.addListener === 'function') {
    desktopMq.addListener(closeMenuIfDesktop);
  }

  closeEls.forEach((el) => {
    el.addEventListener('click', () => setMenuOpen(false));
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && root.classList.contains('header-ectra--menu-open')) {
      setMenuOpen(false);
    }
  });

  if (shell && typeof ResizeObserver !== 'undefined') {
    const ro = new ResizeObserver(() => {
      document.documentElement.style.setProperty('--header-height', `${shell.offsetHeight}px`);
    });
    ro.observe(shell);
    document.documentElement.style.setProperty('--header-height', `${shell.offsetHeight}px`);
  }
})();
